import React from "react";
import { KMenuDropDown } from "@kyburz/kdesign-system";
import { formatDate } from "../../utils/timeUtils";

export const iotKeyColumns = (history, setState) => [
  {
    Header: "Name",
    id: "name",
    accessor: "name",
  },
  {
    Header: "Command",
    id: "command",
    accessor: "command",
  },
  {
    Header: "Companies",
    id: "companies",
    accessor: (row) => row.companies.join(", "),
  },
  {
    Header: "Modified",
    id: "modified",
    accessor: (row) => formatDate(row.modified),
    defaultCanFilter: false,
  },
  {
    accessor: "actions",
    defaultCanFilter: false,
    sticky: "right",
    Cell: (row) => {
      return (
        <KMenuDropDown
          menuItems={[
            {
              icon: "edit",
              title: "Edit",
              action: () => {
                history.push(`/config/iot_commands/${row?.row?.original?.id}`);
              },
            },
            {
              icon: "trash-2",
              title: "Delete",
              action: () => {
                setState({
                  showDeleteDialog: true,
                  iotKeyCommandToDelete: row?.row?.original || null,
                });
              },
            },
          ]}
        />
      )
    },
    width: 50,
  },
];
